import { ScreenComponentMap, ScreenType } from '../../types';
import { CallInsightScreen } from './call-insight-screen';
import { CallPathMappingScreen } from './call-path-mapping-screen';
import { CallQualityDrilldownScreen } from './call-quality-drilldown-screen';
import { CallQualityScreen } from './call-quality-screen';

export const Screens: ScreenComponentMap = {
  get [ScreenType.CALL_INSIGHTS]() {
    return CallInsightScreen;
  },
  get [ScreenType.CALL_QUALITY]() {
    return CallQualityScreen;
  },
  get [ScreenType.CALL_QUALITY_DRILLDOWN]() {
    return CallQualityDrilldownScreen;
  },
  get [ScreenType.CALL_PATH_MAPPING]() {
    return CallPathMappingScreen;
  },
};
